<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Select User</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="form-group">
      <label for="searchUsersInput">Search Users</label>
      <input type="text" class="form-control" id="searchUsersInput"
             name="searchUsersInput"
             ngbAutofocus
             [(ngModel)]="userFilters.search"
             (ngModelChange)="handleUserFilterChange()">
    </div>

    <!-- Add a fixed-height div to prevent the modal from shifting as results are loaded -->
    <div class="mt-3 mb-3" style="height: 231px;overflow-y: auto">

      <table class="table table-bordered table-hover"
             *ngIf="(userFilters.search !== '') && (selectedUser === null)">
        <tbody *ngIf="!userResultsPresent()">
          <tr>
            <td colspan="99">
              {{ loadingUsers ? 'Loading...' : 'No results' }}
            </td>
          </tr>
        </tbody>
        <tbody *ngIf="userResultsPresent()">
          <tr style="cursor:pointer"
              *ngFor="let user of filteredUserResults()"
              (click)="selectUser(user)">
            <td>
              {{ user.first_name }} {{ user.last_name }}
              <span class="text-muted" *ngIf="user.email">
                - {{ user.email }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>

    </div>

    <div class="alert alert-danger" role="alert" *ngIf="errors.non_field_errors">
      {{ errors.non_field_errors }}
    </div>
    <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>

  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button type="button" class="btn btn-primary"
            (click)="handleSave()"
            [disabled]="!validInputSelected()"
            [class.disabled]="!validInputSelected()">
      Submit
    </button>
  </div>

</ng-container>
